import { ColorOptions, Icon, LoaderNew, ModBox } from '@jfs/ui-new'
import { View } from 'react-native'

const StatusStateIcon = ({ isApproved, show, isProgress, status }) => {
  return (
    <ModBox marginTop={16} alignItems={'center'} show={show}>
      <ModBox
        w={40}
        h={40}
        borderRadius={20}
        backgroundColor={isApproved ? ('#E8F1E8' as ColorOptions) : ('#F7ECEC' as ColorOptions)}
        alignItems={'center'}
        justifyContent={'center'}
        marginVertical={10}>
        <ModBox
          show={!isProgress}
          w={24}
          h={24}
          borderRadius={12}
          backgroundColor={isApproved ? ('GREEN' as ColorOptions) : ('#C94949' as ColorOptions)}
          alignItems={'center'}
          justifyContent={'center'}>
          <Icon id={isApproved ? 'TICKMARK' : 'CLOSE'} color={'WHITE'} size={12} />
        </ModBox>
        <ModBox
          show={isProgress && (status !== 'Error' || status !== 'Completed')}
          w={24}
          h={24}
          borderRadius={12}
          backgroundColor={'BACKGROUND_LIGHT'}
          alignItems={'center'}
          justifyContent={'center'}>
          <LoaderNew type={'small'} color={'PRIMARY'} />
        </ModBox>
      </ModBox>
      <View style={styles.viewStyle} />
    </ModBox>
  )
}

const styles = {
  viewStyle: { width: 1, height: 90, backgroundColor: '#000000', opacity: 0.2 },
}

export { StatusStateIcon }
